import { Plus } from "lucide-react";
import { ModalTrigger } from "./ModalTrigger";

interface NewPortfolioTriggerProps {
  accountId: string | number;
  onPortfolioCreated?: () => void;
}

export const NewPortfolioTrigger = ({
  accountId,
  onPortfolioCreated,
}: NewPortfolioTriggerProps) => {
  if (onPortfolioCreated) {
    (window as any).__portfolioCreatedCallback = onPortfolioCreated;
  }

  return (
    <ModalTrigger
      modalPath="/modals/portfolio/create"
      modalState={{ accountId }}
      className="cursor-pointer bg-lime text-foreground hover:text-background w-40 h-8 flex mx-auto"
    >
      <Plus className="w-4 h-4" />
      New Portfolio
    </ModalTrigger>
  );
};
